export default __webpack_public_path__ + "b94105f262f675363e5b091335d5f8af.png";